// -----------------------------------------------------------------------------
// Setzt CSS-Klasse abhängig von Viewport-Breite
// -----------------------------------------------------------------------------

const init = () => {
  setRwdClass();
  window.addEventListener('resize', setRwdClass, true);

  setContentOffset();
  window.addEventListener('resize', setContentOffset, true);
};

const $container = $('.js-body');
const classStrings = {
  mobile: 'js-mobile',
  desktop: 'js-desktop',
  ipad: 'js-ipad'
};

/**
 * Abstand nach oben für Inhaltsbereich abhängig von Header-Höhe setzen
 */
const setContentOffset = () => {
  const headerHeight = document.getElementById('header').offsetHeight;
  document.getElementById('maincontent').style.marginTop = headerHeight + 'px';
};

/**
 * Viewport-Breite ermitteln und entsprechende CSS-Klasse setzen
 */
const setRwdClass = () => {
  resetClasses();

  // CSS-Klasse abhängig von Viewport-Breite setzen
  if ($(window).width() < 992) {
    $container.addClass(classStrings.mobile);
  } else {
    $container.addClass(classStrings.desktop);
  }

  // iPad identifizieren
  if (navigator.userAgent.match(/iPad/i) !== null) {
    $container.addClass(classStrings.ipad);
    $container.attr('ontouchstart', '');
  }
};

/**
 * Alle CSS-Klassen entfernen
 */
const resetClasses = () => {
  Object.keys(classStrings).map(key => {
    $container.removeClass(classStrings[key]);
  });
};

export {
  init
};
